export default __webpack_public_path__ + "435244365be8126462031f8f72cd8342.webp";